import { createSelector } from '@ngrx/store';

import { getPaymentState } from '../getPaymentState';

export const isRedirectPaymentType = createSelector(getPaymentState, (paymentState) => paymentState.redirect?.vendorPayment === true);
